import React from 'react';

const ShowMoreButton = (props) => {

  const {
    handler,
    additionalClasses = [],
  } = props;

  return (
    <span className={`popup-info__show-more ${additionalClasses.join(' ')}`}
          onClick={handler}
    >Показать полностью</span>
  );
};

export default ShowMoreButton;